/**
 * The typed checklist items (piece 29; T389; decision 2110): the five kinds'
 * names, the job's checklist on the visit's page and My Jobs, and the
 * template editor under Settings › Service. Spread into the one lookup in
 * `strings.ts`. 🔨 This file imports nothing.
 */
export const CHECKLIST_STRINGS = {
  'checklist.kind.tick': 'Tick',
  'checklist.kind.reading': 'Reading',
  'checklist.kind.passFail': 'Pass or Fail',
  'checklist.kind.photo': 'Photo',
  'checklist.kind.signature': 'Signature',
  'checklist.kind.choice': 'Choice',
  // The job's checklist, answered on the visit's page and from a My Jobs card.
  'checklist.job.title': 'Checklist',
  'checklist.job.none': 'No checklist stands on this job. A checklist is added from a line’s Asset on the Work Order.',
  'checklist.job.progress': '{closed} of {total} answered',
  'checklist.job.open': 'Open',
  'checklist.job.done': 'Done',
  'checklist.job.markDone': 'Mark Done',
  'checklist.job.reading': 'Reading',
  'checklist.job.unit': 'Unit',
  'checklist.job.range': 'Accepted range: {low} to {high} {unit}',
  'checklist.job.rangeFrom': 'Accepted range: {low} {unit} and above',
  'checklist.job.rangeTo': 'Accepted range: up to {high} {unit}',
  'checklist.job.save': 'Save',
  'checklist.job.pass': 'Pass',
  'checklist.job.fail': 'Fail',
  'checklist.job.failNote': 'What Failed',
  'checklist.job.saveFail': 'Save Fail',
  'checklist.job.takePhoto': 'Take or Upload Photo',
  'checklist.job.viewPhoto': 'View Photo',
  'checklist.job.photoTaken': 'Photo taken',
  'checklist.job.sign': 'Sign',
  'checklist.job.signTitle': 'Sign This Step',
  'checklist.job.signerName': 'Signer’s Name',
  'checklist.job.pad': 'Signature',
  'checklist.job.signedBy': 'Signed by {name}',
  'checklist.job.passed': 'Pass',
  'checklist.job.failed': 'Fail: {note}',
  'checklist.job.outOfRange': 'Out of range',
  'checklist.job.answeredBy': 'Answered by {name}, {when}',
  'checklist.job.clear': 'Clear',
  'checklist.job.settled': 'The job is finished, so its checklist stands as it was left.',
  'checklist.job.readOnly': 'You can read this checklist. The lead of a visit on this job, or a holder of write on the Work Order, answers it.',
  'checklist.job.openFromCard': 'Checklist · {closed} of {total}',
  // Decision 2111 (T889): a manager's sign-off on an item left unanswered.
  'checklist.job.signOff': 'Sign Off',
  'checklist.job.signOffTitle': 'Sign Off an Unanswered Item',
  'checklist.job.signOffHint': 'The job completes with this item unanswered once you sign it off. Say why it was not done; the reason stays on the job’s history.',
  'checklist.job.signOffReason': 'Why It Was Not Done',
  // 🔒 Decisions 2280, 2400: the procedure an item cites, opened full width, and the version a completed item was completed against.
  'checklist.job.procedure': 'Procedure',
  'checklist.job.openProcedure': 'Open Procedure',
  'checklist.job.back': 'Back',
  'checklist.job.completedAgainst': 'Completed against version {n}',
  'checklist.job.procedureMissing': 'This procedure has no published version you can read.',
  'checklist.job.signedOff': 'Signed off by {name}: {reason}',
  'checklist.job.waiting': 'Reading the checklist.',
  'checklist.job.unansweredStop': 'Answer each item, or a manager signs it off, before the job completes. Unanswered: {items}',
  'checklist.page.title': 'Checklist for {number}',
  'checklist.page.kind': 'Job Checklist',
  'checklist.page.backToJob': 'Back to {number}',
  'checklist.page.open': 'Checklist',
  // The Knowledge section's Checklists tab (decision 2110, moved by decision 2281).
  'checklist.templates.hint': 'The checklists a line’s Asset offers on a Work Order. Each item asks for a tick, a reading with its unit, pass or fail, a pick from a list, a photo or a signature. A checklist already on a job keeps the items it was written with.',
  'checklist.templates.none': 'No checklist template exists yet. Add one to offer it on a job.',
  'checklist.templates.new': 'New Template',
  'checklist.templates.name': 'Template Name',
  'checklist.templates.add': 'Add Template',
  'checklist.templates.items': 'Items',
  'checklist.templates.noItems': 'No item yet.',
  'checklist.templates.item': 'Item',
  'checklist.templates.asks': 'Asks For',
  'checklist.templates.unit': 'Unit',
  'checklist.templates.low': 'Low Limit',
  'checklist.templates.high': 'High Limit',
  'checklist.templates.save': 'Save',
  'checklist.templates.addItem': 'Add Item',
  'checklist.templates.itemTitle': 'New Item',
  'checklist.templates.saved': 'Saved.',
  'checklist.templates.inactive': 'Inactive',
  // Decision 2112 (T1168): a Choice's options, one per line.
  'checklist.templates.options': 'Options, One per Line',
  // 🔒 Decision 2280: the procedure an item cites, picked from the published articles.
  'checklist.templates.procedure': 'Procedure',
  'checklist.templates.procedureEntity': 'Article',
  'checklist.templates.noProcedure': 'No Procedure',
  // 🔒 Decision 12580: the article a template's list follows, set on its card with Clear.
  'checklist.templates.workInstruction': 'Work Instruction',
  'checklist.templates.noWorkInstruction': 'No Work Instruction',
  'checklist.templates.clearWorkInstruction': 'Clear',
  'checklist.templates.clearWorkInstructionNone': 'No work instruction is set on this template.',
  'checklist.job.openWorkInstruction': 'Open Work Instruction',
  // 🔒 Decision 12581: the article as a job's checklist's working view.
  'checklist.working.progress': '{closed} of {total} done',
  'checklist.working.back': 'Back to the Job',
  'checklist.working.alsoOnList': 'Also on This List',
  'checklist.working.moved': 'This article has changed since the list was made, so items whose step it no longer carries stand under Also on This List.',
  'checklist.working.step': 'Step {n}',
  'checklist.working.note': 'Note',
  'checklist.working.saveNote': 'Save Note',
  'checklist.working.noteSaved': 'Note saved.',
  'checklist.working.noteUnchanged': 'The note is as it was saved.',
  'checklist.working.addPhoto': 'Add Photo',
  'checklist.working.saving': 'Saving.',
  'checklist.working.photo': 'Photo {n}',
  'checklist.working.photoAdded': 'Photo added.',
  'checklist.working.photoCount': 'Photos: {count}',
  'checklist.working.instructions': 'Work Instructions',
  // 🔒 Decision 12582: Create Checklist on a published article.
  'checklist.create.open': 'Create Checklist',
  'checklist.create.title': 'Create Checklist',
  'checklist.create.found': 'Each step this article numbers is proposed as an item. Untick, reword, reorder or add items, then Save.',
  'checklist.create.none': 'No steps were found in this article, so add the items by hand.',
  'checklist.create.name': 'Template Name',
  'checklist.create.offeredOn': 'Offered On',
  'checklist.create.offeredOnWorkOrder': 'Work Order',
  'checklist.create.offeredOnAsset': 'Asset',
  'checklist.create.offeredOnSite': 'Site',
  'checklist.create.offeredOnCompany': 'Company',
  'checklist.create.offeredOnDeal': 'Deal',
  'checklist.create.offeredOnEmployee': 'Employee',
  'checklist.create.item': 'Item {n}',
  'checklist.create.keep': 'Keep',
  'checklist.create.fromStep': 'Step {n}',
  'checklist.create.byHand': 'Added by hand',
  'checklist.create.addItem': 'Add Item',
  'checklist.create.remove': 'Remove',
  'checklist.create.moveUp': 'Move Up',
  'checklist.create.moveDown': 'Move Down',
  'checklist.create.save': 'Save',
  'checklist.create.needsName': 'Name the template first.',
  'checklist.create.needsItem': 'Keep at least one item with its words.',
  'checklist.create.firstAlready': 'This item is already first.',
  'checklist.create.lastAlready': 'This item is already last.',
  'checklist.create.workInstruction': 'Work Instruction',
  // 🔒 Decision 12583: Update from Article on a template whose article moved.
  'checklist.update.moved': 'Moved',
  'checklist.update.added': 'Added',
  'checklist.update.unchanged': 'Unchanged',
  'checklist.update.gone': 'No Longer Found',
  'checklist.update.title': 'Update from Article',
  'checklist.update.open': 'Update from Article',
  'checklist.update.articleMoved': 'The article has a newer version than this list was made from (version {from}, now version {to}).',
  'checklist.update.hint': 'Each step of the newest version against this list. Untick a line to leave it as it stands; items added by hand are kept.',
  'checklist.update.save': 'Save',
  'checklist.update.reading': 'Reading the article’s newest version.',
  'checklist.working.instructionsHint': 'Each checklist on this job that follows an article; open one to work the list inside it.',
  'checklist.working.answerOnJob': 'This item asks for a typed answer; answer it on the job’s checklist.',
  'checklist.working.unavailable': 'This checklist names no work instruction you can read here.',
  'checklist.procedure.archived': 'Archived',
  'checklist.job.choice': 'Pick One',
} as const;
